import { Controller } from "@hotwired/stimulus";
import { Turbo } from "@hotwired/turbo-rails";

/**
 * Handles date selection for the floor plan view
 *
 * Values:
 * - url: Base URL for the floor plan page
 *
 * Targets:
 * - calendar: The date input element
 */
export default class extends Controller {
  static targets = ["calendar"];
  static values = {
    url: String,
  };

  dateChanged(event) {
    const selectedDate = event.target.value;
    if (!selectedDate) return;

    this.navigateToDate(selectedDate);
  }

  previousDay() {
    const currentDate = this.parseLocalDate(this.calendarTarget.value);
    currentDate.setDate(currentDate.getDate() - 1);
    this.navigateToDate(this.formatDate(currentDate));
  }

  nextDay() {
    const currentDate = this.parseLocalDate(this.calendarTarget.value);
    currentDate.setDate(currentDate.getDate() + 1);
    this.navigateToDate(this.formatDate(currentDate));
  }

  today() {
    this.navigateToDate(this.formatDate(new Date()));
  }

  parseLocalDate(dateString) {
    const [year, month, day] = dateString.split("-").map(Number);
    return new Date(year, month - 1, day);
  }

  navigateToDate(date) {
    const url = new URL(window.location.href);
    url.searchParams.set("date", date);
    Turbo.visit(url.toString());
  }

  formatDate(date) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  }
}
